import { render } from "./UiTestSmgReport.vue?vue&type=template&id=adc39b42&scoped=true&ts=true"
import script from "./UiTestSmgReport.vue?vue&type=script&lang=ts"
export * from "./UiTestSmgReport.vue?vue&type=script&lang=ts"

import "./UiTestSmgReport.vue?vue&type=style&index=0&id=adc39b42&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adc39b42"]])

export default __exports__